<template>
  <div class="footer">
    <div v-if="white === true" class="white padBttm">
      <b-row class="FooterSponsorsSup" >
        <b-col lg='12' md='12'>
          <b-row>
            <b-col>
              <h2 class="spontitle" style="padding-top: 10px; padding-bottom:10px">
                Sponsors / Partners
              </h2>
            </b-col>
          </b-row>

          <template v-if="isMobile(true)">
            <b-row>
              <b-col
              lg='3' md='6' cols='4'
                :class="{ hide: logo.acf.supplier, show: logo.acf.partner }"
                class="logoPadding"
                v-for="(logo, index) in footG.slice(0,10)"
                :key="index"
              >
                <p class="logoTitle">{{logo.acf.image_title}}</p>
                <a :href="logo.acf.url" target="_blank">
                  <img class="logos" :src="logo.acf.image" />
                </a>
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-row>
              <b-col
              lg='3' md='6' cols='12'
                :class="{ hide: logo.acf.supplier, show: logo.acf.partner }"
                class="logoPadding"
                v-for="(logo, index) in footG.slice(0,8)"
                :key="index"
              >
                <p class="logoTitle">{{logo.acf.image_title}}</p>
                <a :href="logo.acf.url" target="_blank">
                  <div class="outerLogoImg">
                    <b-img class="logoImg" :src="logo.acf.image" :class="{big : logo.acf.image == 'https://ocs-sport.ams3.cdn.digitaloceanspaces.com/bvt/2024/06/betway-big-easy-tour-FA-01.png'}"/>
                  </div>
                </a>
              </b-col>
            </b-row>
            <b-row>
              <b-col
              lg='3' md='6' cols='12'
              ></b-col>
              <b-col
              lg='3' md='6' cols='12'
                :class="{ hide: logo.acf.supplier, show: logo.acf.partner }"
                class="logoPadding"
                v-for="(logo, index) in footG.slice(8,10)"
                :key="index"
              >
                <p class="logoTitle">{{logo.acf.image_title}}</p>
                <a :href="logo.acf.url" target="_blank">
                  <div class="outerLogoImg">
                    <b-img class="logoImg" :src="logo.acf.image" />
                  </div>
                </a>
              </b-col>
            </b-row>
          </template>
        </b-col>
        <!-- <b-col lg='6' md='12' cols='12'>
          <b-row>
            <b-col>
              <h2 class="title suppliersText">
                Suppliers
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col
            lg='3' md='6' cols='6'
              :class="{ hide: logo.acf.partner, show: logo.acf.supplier }"
              class="logoPadding suppliersLogo"
              v-for="(logo, index) in footW"
              :key="index"
            >
              <a :href="logo.acf.url" target="_blank">
                <img class="logos" :src="logo.acf.image" />
              </a>
            </b-col>
          </b-row>
        </b-col> -->
      </b-row>
    </div>
    <div v-if="white === false" class="grey padBttm">
      <b-row class="FooterSponsorsSup" :class="{contactMarg: this.$route.name === 'contact'}">
        <b-col lg='12' md='12'>
          <b-row>
            <b-col>
              <h2 class="spontitle" style="padding-top: 10px; padding-bottom:10px">
                Sponsors / Partners
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col
            lg='3' md='6' cols='12'
              :class="{ hide: logo.acf.supplier, show: logo.acf.partner }"
              class="logoPadding"
              v-for="(logo, index) in footG.slice(0,8)"
              :key="index"
            >
              <p class="logoTitle">{{logo.acf.image_title}}</p>
              <a :href="logo.acf.url" target="_blank">
                <img class="logos" :src="logo.acf.image" />
              </a>
            </b-col>
          </b-row>
          <b-row>
            <b-col
            lg='3' md='6' cols='12'
            ></b-col>
            <b-col
            lg='3' md='6' cols='12'
              :class="{ hide: logo.acf.supplier, show: logo.acf.partner }"
              class="logoPadding"
              v-for="(logo, index) in footG.slice(8,10)"
              :key="index"
            >
              <p class="logoTitle">{{logo.acf.image_title}}</p>
              <a :href="logo.acf.url" target="_blank">
                <img class="logos" :src="logo.acf.image" />
              </a>
            </b-col>
          </b-row>
        </b-col>
        <!-- <b-col lg=6 md='12'>
          <b-row>
            <b-col>
              <h2 class="title suppliersText">
                Suppliers
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col
            lg='3' md='6' cols='6'
              :class="{ hide: logo.acf.partner, show: logo.acf.supplier }"
              class="logoPadding suppliersLogo"
              v-for="(logo, index) in footG"
              :key="index"
            >
              <a :href="logo.acf.url" target="_blank">
                <img class="logos" :src="logo.acf.image" />
              </a>
            </b-col>
          </b-row>
        </b-col> -->
      </b-row>

    </div>
    <div v-if="contactF === true" class="contact padBttm">
      <b-row class="container FooterSponsorsSup">
        <b-col md='12'>
          <b-row>
            <b-col>
              <h2 class="spontitle" style="padding-top: 10px; padding-bottom:10px">
                Sponsors / Partners
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col
            lg='3' md='6' cols='12'
              :class="{ hide: logo.acf.supplier, show: logo.acf.partner }"
              class="logoPadding"
              v-for="(logo, index) in footG.slice(0,8)"
              :key="index"
            >
              <p class="logoTitle">{{logo.acf.image_title}}</p>
              <a :href="logo.acf.url" target="_blank">
                <img class="logos" :src="logo.acf.image" />
              </a>
            </b-col>
          </b-row>
          <b-row>
            <b-col
            lg='3' md='6' cols='12'
            ></b-col>
            <b-col
            lg='3' md='6' cols='12'
              :class="{ hide: logo.acf.supplier, show: logo.acf.partner }"
              class="logoPadding"
              v-for="(logo, index) in footG.slice(8,10)"
              :key="index"
            >
              <p class="logoTitle">{{logo.acf.image_title}}</p>
              <a :href="logo.acf.url" target="_blank">
                <img class="logos" :src="logo.acf.image" />
              </a>
            </b-col>
          </b-row>
        </b-col>
        <!-- <b-col md='12'>
          <b-row>
            <b-col>
              <h2 class="title suppliersText">
                Suppliers
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col
            lg='3' md='6'
              :class="{ hide: logo.acf.partner, show: logo.acf.supplier }"
              class="logoPadding suppliersLogo"
              v-for="(logo, index) in footW"
              :key="index"
            >
              <a :href="logo.acf.url" target="_blank">
                <img class="logos" :src="logo.acf.image" />
              </a>
            </b-col>
          </b-row>
        </b-col> -->
      </b-row>
    </div>
      <!-- <div id="social" :class="{contactHide : $route.name === 'contact'}">
        <b-row>
          <b-col lg='6' md='12' cols='12'>
            <Twitter :config="config"/>
          </b-col>
          <b-col lg='6' md='12' cols='12'>
            <Instagram :config='config'/>
          </b-col>
        </b-row>
      </div> -->
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
// import Twitter from '@/components/twitterFeed.vue'
// import Instagram from '@/components/instaFeed.vue'

export default {
  name: "Footer",
  props: ["white", 'contactF', "config"],
  components:{
    // Twitter,
    // Instagram
  },
  data() {
    return {
      footW: [],
      footG: [],
      logoImg: "logoImg",
      ocsLogo: "ocsLogo",
      logoRow: "logoRow",
      logoRowMobile: "logoRowMobile",
      hover: false,
    };
  },
  methods: {
    isMobile() {
      if( screen.width <= 500 ) {
        return true;
      }
      else {
        return false;
      }
    },
  },
  async mounted() {
    var one = "wp/v2/FooterBottom?per_page=25" + "&randomadd=" + new Date().getTime();
    var two = "wp/v2/FooterBottomWhite?per_page=25" + "&randomadd=" + new Date().getTime();
    try {
      // First call, await for call to return
      let first_call = await apiCall.wpInfo(one);
      this.footG = first_call.data;
      this.loading = false;
      // Second call, await for call to return
      let second_call = await apiCall.wpInfo(two);
      this.footW = second_call.data;
      this.loading = false;
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      throw error;
    }
  }
};
</script>

<style scoped>
.logoPadding.col-md-6.col-lg-3.col-12.show:first-child {
  position: relative;
  top: -40px;
}
.logoImg {
  width: 100%;
}
.outerLogoImg {
  width: 150px;
  height: 112px;
  margin: auto;
}
.logoPadding.col-md-6.col-lg-3.col-4.show:last-child {
  flex: 100%;
  max-width: 100%;
}
.padBttm {
  padding-bottom: 2.5em;
}
p.logoTitle {
  font-weight: 700;
}
.spontitle {
  padding-left: 4%;
  font-weight: 700;
  margin-bottom: 1em;
  margin-top: 1em;
  text-align: center;
  color: #000;
}
.contactHide {
  display: none;
}
.contactMarg{
  margin-bottom:0px!important;
  padding-bottom: 30px;
}
.logoPadding.suppliersLogo.col-md-6.col-lg-3.show {
  padding: 1%;
  display: inline-table;
  margin-left: 25px;
  padding-bottom: 15px;
}

.logoPadding.suppliersLogo.col-md-6.col-lg-3.show {
  padding: 1%;
  display: inline-table;
  margin-left: 25px;
  padding-bottom: 15px;
}
img.maleFooter {
  width: 100%;
}
.white > div > img {
  width: 100%;
}
.col-md-3.logoPadding {
  margin-top: 30px;
  margin-bottom: 30px;
}
.FooterSponsorsSup {
  margin: auto;
  padding-left: 100px;
  padding-right: 100px;
}
.logos {
  /* width: 210px; */
  /* width: 100%; */
  width: 165px;
}
.hide {
  display: none;
}
.show {
  /* padding: 2%; */
  padding: 0%;
  text-align: center;
}
/* ::v-deep .show:nth-last-child(-n + 2) {
  flex: 0 0 25%;
  max-width: 25%;
} */
.title {
  padding-left: 4%;
  font-weight: 400;
  margin-bottom: 2em;
  margin-top: 1em;
  text-align: center;
}
.grey{
  padding-top: 2%;
  /* background-color: #F0F0F0; */
}
.white{
  padding-top: 2%;
}
.contact{
  padding-top: 12%;
}
#social{
  padding: 50px;
}
.mobile{
  display: none;
}
img.logoImg.big {
  margin-top: -30px;
}
@media only screen and (max-width: 990px) {
  .show {
    padding: 1%;
    text-align: left;
  }
}
@media only screen and (max-width: 768px) {
  .logos{
    text-align: center;
    margin: auto;
    display: block;
    width: 100px;
  }
  .logoPadding.suppliersLogo.col-md-6.col-lg-3.show {
    margin-left: 0;
  }
}
@media only screen and (max-width: 500px) {
  ::v-deep p.logoTitle {
    font-weight: 700;
    text-align: center;
    font-size: large;
  }
  ::v-deep .show {
    padding: 0%!important;
    text-align: left;
  }
  ::v-deep .title {
    padding-left: 4%;
    font-weight: 400;
    margin-bottom: 2em;
    margin-top: 1em;
    text-align: center;
  }
   .desktop{
    display: none;
  }
  .mobile{
    display: block;
  }
  .FooterSponsorsSup {
  margin: auto;
  padding-left: 25px!important;
  padding-right: 25px!important;
}
}
</style>
